<template>
    <div v-if="visible">
        <div v-if="delivery || noTable" class="popup__header">
            <span class="title title--sm popup__title">{{ $lang('Delivery.title') }}</span>
        </div>

        <div v-else-if="!delivery" style="padding-top: 30px"></div>

        <div class="popup__content popup__content--pt-small">
            <delivery-location v-if="!delivery && !noTable"
                               :delivery.sync="delivery"
                               :hidden-no-table="propPaymentType === paymentTypes.table"
                               @noTable="noTable = true"
            >
            </delivery-location>

            <delivery-order v-if="delivery || noTable"
                            :delivery.sync="delivery"
                            :order="order"
                            :product-name="productName"
                            :product-price="productPrice"
                            :payment-type="paymentType"
                            :not-paid="notPaid"
                            :copyright="propCopyright"
                            @back="backToLocation"
                            @onSubmit="sendOrder"
            >
            </delivery-order>
        </div>
    </div>
</template>

<script>
import DeliveryLocation from './DeliveryLocation'
import DeliveryOrder from './DeliveryOrder'
import ApiService from "../../api/api";

export default {
    name: "Delivery",
    props: [ 'propProductName', 'propProductPrice', 'propPaymentType', 'propCopyright', 'propTree'],
    components: {
        DeliveryLocation,
        DeliveryOrder
    },
    data() {
        return {
            visible: false,
            locale: window.laravel.locale,
            pageId: this.$route.params.id,
            notPaid: false,
            paymentTypes: window.laravel.paymentTypes,
            productName: this.propProductName,
            productPrice: this.propProductPrice,
            paymentType: this.propPaymentType,
            delivery: null,
            order: {
                plateAttachment: false,
            },
            noTable: false,
            tree: this.propTree
        }
    },
    created() {
       if (this.$route.name === 'order') {
            this.setUnpaidPayment();
        } else if (!this.propProductName || this.productName === undefined || this.propProductPrice === 0
            || this.propProductPrice === undefined) {
            this.redirectToHome();
        } else {
            this.visible = true;
        }
    },
    methods: {
        sendOrder(order) {
            this.order = order;
            let params = {
                product_name: this.productName,
                product_price: this.productPrice,
                page_id: this.pageId,
                payment_type: this.paymentType,
                price: this.order.sum,
                copyright: !!this.propCopyright,
                burial: false,
                phone: this.order?.phone,
                no_table: this.noTable,
                locale: this.locale,
                tree: this.tree
            };

            if (this.delivery) {
                this.$set(params, 'delivery_period', this.delivery.period);
                this.$set(params, 'delivery_workschedule', this.delivery.workschedule);
                this.$set(params, 'delivery_method', this.delivery.method);
                this.$set(params, 'delivery_method_name', this.delivery.methodName);
                this.$set(params, 'delivery_price', this.delivery.price);
                this.$set(params, 'delivery_address', this.delivery.address);
                this.$set(params, 'plate_attachment', this.order.plateAttachment);
            }

            if (this.order && this.order.promoCodeId) {
                this.$set(params, 'promo_code_id', this.order.promoCodeId);
            }

            params = new URLSearchParams(params);

            this.redirectTo(window.laravel.prefix + `/payment?${params.toString()}`);
        },
        setUnpaidPayment() {
            this.visible = false;

            this.$loading(this.$optionsLoading);

            ApiService.get('/payment/last-unpaid-payment').then((response) => {
                if (!response.data) {
                    this.redirectToHome();
                }

                let paymentLocale = response.data.payment_detales.locale;

                if(paymentLocale !== this.locale) {
                    return location.href= '/' + paymentLocale + '/order';
                }

                this.notPaid = true;
                this.noTable = response.data.payment_detales.noTable;
                this.delivery = response.data.delivery_details;
                this.productName = response.data.payment_detales.productName;
                this.productPrice = response.data.payment_detales.productPrice;
                this.order.plateAttachment = response.data.payment_detales.plateAttachment;
                this.pageId = response.data.page.id;
                this.paymentType = response.data.payment_type_id;
                this.$loading({}).close();
                this.visible = true;
            })
        },
        redirectToHome() {
            return location.href = window.laravel.prefix + '/';
        },
        redirectTo(path) {
            window.location.href = this.forceRedirectToPath
                ? this.forceRedirectToPath
                : path;
        },
        backToLocation() {
            this.notPaid = false;
            this.noTable = false;
            this.delivery = null;
            this.order = null;
        },
    },
}
</script>
